import {ChangeEvent, FC} from 'react'

import {TextVariant} from '@/components/common/content/Text'
import {MinusIcon} from '@/components/common/icons/MinusIcon'
import {PlusIcon} from '@/components/common/icons/PlusIcon'
import {theme} from '@/theme/theme'
import {analytics} from '@/utils/tracking/analytics'
import {AnalyticsTrackedEvent} from '@/utils/tracking/types'

type NumberInputProps = {
  value: number
  setValue: (value: number) => void
  minValue: number
  trackedEvent: AnalyticsTrackedEvent
  textVariant?: TextVariant
  buttonSize?: number
}

export const NumberInput: FC<NumberInputProps> = ({
  value,
  setValue,
  minValue,
  trackedEvent,
  textVariant = TextVariant.text14,
  buttonSize = 32,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => setValue(parseInt(e.target.value))

  const changeCount = (difference: 1 | -1) => {
    setValue(Math.max(value + difference, minValue))
    analytics.track(trackedEvent.name, trackedEvent.parameters)
  }

  return (
    <>
      <div className="selector">
        <button className="button" type="button" onClick={() => changeCount(-1)}>
          <MinusIcon />
        </button>
        <input
          type="text"
          value={value}
          min={minValue}
          className="input"
          placeholder={`${minValue}`}
          onChange={handleChange}
        />
        <button className="button" type="button" onClick={() => changeCount(1)}>
          <PlusIcon />
        </button>
      </div>

      <style jsx>{`
        .selector {
          display: flex;
        }
        .input {
          ${theme.typography[textVariant].desktop};
          color: ${theme.palette.text.default};
          background-color: transparent;
          padding: 0;
          width: 36px;
          text-align: center;
          border-radius: 8px;
        }
        .input:focus {
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[900]},
            0px 0px 0px 4px ${theme.palette.gray[100]};
        }
        input[type='number']::-webkit-outer-spin-button,
        input[type='number']::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input[type='number'] {
          -webkit-appearance: none;
          -moz-appearance: textfield;
          margin: 0;
        }
        .button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: ${buttonSize}px;
          height: ${buttonSize}px;
          flex-shrink: 0;
          ${theme.typography.h4.desktop};
          color: ${theme.palette.text.default};
          background-color: ${theme.palette.background.default};
          border: 1px solid ${theme.palette.gray[300]};
          border-radius: 8px;
          cursor: pointer;
        }
        .button:hover {
          background-color: ${theme.palette.gray[50]};
        }
      `}</style>
    </>
  )
}
